/* Separate pack for Turbo, so that we can call the turbo JS script from the head tag (and defer it).
 * If we added Turbo to our application.js pack (which is currently called from the <body> tag), that would generate a warning, hence this dedicated pack
 *
 * By default Turbo is disabled everywhere, and enabled on a case-by-case basis as explained here :
 * https://turbo.hotwired.dev/handbook/drive#disabling-turbo-drive-on-specific-links-or-forms
 */
import { Turbo } from "@hotwired/turbo-rails";
import { notifyError } from "../components/flash_alert";
import { originalResponseFromTurboResponseEvent } from "../utils/turbo_utils";
Turbo.session.drive = false;

// This line should be used to make Turbo behaviour on form only optin (so disabled by default)
// We didn't manage to make it work, so we added a data-turbo="false" attribute in the body tag to do the same job
// More details here: https://github.com/hotwired/turbo/pull/419 or https://stackoverflow.com/questions/70921317/how-can-i-disable-hotwire-turbo-the-turbolinks-replacement-for-all-forms-in
// Turbo.config.forms.mode = "optin";

const interceptServerErrorMessage = function (event) {
  const status = originalResponseFromTurboResponseEvent(event).status;

  if (status > 499) {
    notifyError();
    event.preventDefault();
  }
};

document.addEventListener("turbo:before-fetch-response", interceptServerErrorMessage);
